import styles from './ColorSwatch.module.css';

export interface ColorSwatchProps {
  label: string;
  rgb: string;
  onChange: (rgb: string) => void;
  className?: string;
}

/**
 * Color preview and editor for RGB triplet values.
 *
 * Unlike the web-components ColorSwatch (which uses hex), this operates on
 * raw RGB triplets ("25, 117, 240") matching the token manifest format.
 */
export function ColorSwatch({
  label,
  rgb,
  onChange,
  className,
}: ColorSwatchProps) {
  const hex = rgbToHex(rgb);

  return (
    <div
      data-crd-id="r2.bq-designer-color-swatch"
      data-crd-layer="r2"
      className={`${styles.swatch} ${className ?? ''}`}
    >
      <span className={styles.label}>{label}</span>
      <div className={styles.pickerWrap}>
        <input
          type="color"
          className={styles.picker}
          value={hex}
          onChange={(e) => onChange(hexToRgb(e.target.value))}
          aria-label={label}
        />
        <code className={styles.rgb}>{rgb}</code>
      </div>
    </div>
  );
}

function rgbToHex(rgb: string): string {
  const parts = rgb.split(',').map((s) => parseInt(s.trim(), 10));
  if (parts.length !== 3 || parts.some((n) => isNaN(n))) return '#000000';
  return (
    '#' +
    parts.map((n) => Math.max(0, Math.min(255, n)).toString(16).padStart(2, '0')).join('')
  );
}

function hexToRgb(hex: string): string {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `${r}, ${g}, ${b}`;
}
